export enum PoiType {
  HOTEL = 'HOTEL',
  HOSTEL = 'HOSTEL',
  STAMP = 'STAMP'
}
